/**
 * Renders an ISO-8601 instant in the visitor's local timezone and preferred locale
 * (browser/OS settings). Use for all request timestamps from Firestore (stored in UTC).
 */
export function formatInstantInUserTimezone(isoUtc: string | undefined | null): string {
  if (
    isoUtc === null ||
    isoUtc === undefined ||
    !String(isoUtc).trim()
  ) {
    return '—';
  }
  const d = new Date(String(isoUtc).trim());
  if (Number.isNaN(d.getTime())) return '—';
  try {
    return new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'medium',
    }).format(d);
  } catch {
    return d.toLocaleString();
  }
}
